import { mapResponsiveValue } from "../css/atoms/sprinkles.css.mjs";
const alignToFlexAlignLookup = {
  left: "flexStart",
  center: "center",
  right: "flexEnd"
};
const alignToFlexAlign = (align) => align ? mapResponsiveValue(align, (value) => alignToFlexAlignLookup[value]) : void 0;
const alignYToFlexAlignLookup = {
  top: "flexStart",
  center: "center",
  bottom: "flexEnd"
};
const alignYToFlexAlign = (alignY) => alignY ? mapResponsiveValue(alignY, (value) => alignYToFlexAlignLookup[value]) : void 0;
export {
  alignToFlexAlign,
  alignYToFlexAlign
};
